import { Component, OnInit } from '@angular/core';
import { AuthorizeService } from 'src/app/services/authorize/authorize.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
    isOneTank = false;
    isOneTankAdmin = false;
    isOneTankEmployee = false;
    isDistributor = false;
    isDistributorAdmin = false;
    isViewOnlyDistAdmin = false;
    isDistributorEmployee = false;
    isCustomer = false;
    isManufacturing = false;


  constructor(
    private _authorizeService: AuthorizeService
  ) { }

  ngOnInit() {

    this._authorizeService.user$.subscribe(user => {
        if (user?.roleName?.includes("One-Tank Employee")) {
            this.isOneTank = true;
            this.isOneTankEmployee = true;
        }
        if (user?.roleName?.includes("One-Tank Admin")) {
            this.isOneTank = true; 
            this.isOneTankAdmin = true;
        }
        if (user?.roleName?.includes("Distributor")) {
          this.isDistributor = true;

          if (user?.roleName?.includes("Employee"))
            this.isDistributorEmployee = true;
          if (user?.roleName?.includes("Distributor Admin"))
            this.isDistributorAdmin = true;
          if (user?.roleName?.includes("View Only - Admin Distributor"))
            this.isViewOnlyDistAdmin = true;
        }

        if (user?.roleName?.includes("Customer")) {
          this.isCustomer = true;
        }
        
        if (user?.roleName?.includes('Manufacturing') && !user?.roleName?.includes('ManufacturingAdmin'))
            this.isManufacturing = true;
    });

    const body = document.querySelector('body');

    // add class 'hover-open' to sidebar navitem while hover in sidebar-icon-only menu
    document.querySelectorAll('.sidebar .nav-item').forEach(function (el) {
      el.addEventListener('mouseover', function() {
        if(body?.classList.contains('sidebar-icon-only')) {
          el.classList.add('hover-open');
        }
      });
      el.addEventListener('mouseout', function() {
        if(body?.classList.contains('sidebar-icon-only')) {
          el.classList.remove('hover-open');
        }
      });
    });

    document.querySelector('#sidebar')?.addEventListener('mouseleave', function() {
      document.querySelector('.sidebar-offcanvas')?.classList.toggle('active');
    });
  }

}
